/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import ClearIcon from '@mui/icons-material/Clear';
import MenuIcon from '@mui/icons-material/Menu';
import PauseIcon from '@mui/icons-material/Pause';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import { ContentCopy, CopyAll } from '@mui/icons-material';
import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';
type MuiIconsMaterialProps = any

export const ArgosCancelIcon = (props: MuiIconsMaterialProps) => {
  return (
    <ClearIcon
      {...props}
    />
  )
}

export const ArgosDeleteIcon = (props: MuiIconsMaterialProps) => {
  return (
    <DeleteIcon
      {...props}
    />
  )
}
export const ArgosDeleteAllIcon = (props: MuiIconsMaterialProps) => {
  return (
    <DeleteSweepIcon
      {...props}
    />
  )
}
export const ArgosExecuteIcon = (props: MuiIconsMaterialProps) => {
  return (
    <PlayArrowIcon
      {...props}
    />
  )
}

export const ArgosMenuIcon = (props: MuiIconsMaterialProps) => {
  return (
    <MenuIcon
      {...props}
    />
  )
}

export const ArgosPauseIcon = (props: MuiIconsMaterialProps) => {
  return (
    <PauseIcon
      {...props}
    />
  )
}

export const ArgosCopy = (props: MuiIconsMaterialProps) => {
  return (
    <ContentCopy
      {...props}
    />
  )
}
export const ArgosCopyTwoTone = (props: MuiIconsMaterialProps) => {
  return (
    <ContentCopyTwoToneIcon
      {...props}
    />
  )
}
export const ArgosCopyAll = (props: MuiIconsMaterialProps) => {
  return (
    <CopyAll
      {...props}
    />
  )
}